import { useRibbonExpansionControls } from './hooks/useRibbonExpansionControls';
import { useSSOLoginTracking } from './hooks/useSSOLoginTracking';
import Brand from './components/Brand';
import ExpandableMenu from './components/ExpandableMenu';
import InfoButton from './components/InfoButton';
import UserAccountSection from './components/UserAccountSection';
import './styles/styles.scss';
import styles from './InformaPingIdentityRibbon.module.scss';

export default function InformaPingIdentityRibbon() {
  useSSOLoginTracking();

  const { isExpanded, ribbonRef, handleToggleExpanded } =
    useRibbonExpansionControls();

  return (
    <section className={styles.ribbon} ref={ribbonRef}>
      <div className={styles.container}>
        <Brand />
        <div className={styles.userActions}>
          <InfoButton isExpanded={isExpanded} onClick={handleToggleExpanded} />
          <UserAccountSection />
        </div>
      </div>

      <ExpandableMenu isExpanded={isExpanded} />
    </section>
  );
}
